import React from 'react';
import pluralize from 'pluralize';

interface CreateSpaceConfirmationProps {
  title: string;
  uniqDataLength: number;
  parentClasses?: {
    bold?: string;
  };
}

const CreateSpaceConfirmation = ({
  title,
  parentClasses,
  uniqDataLength,
}: CreateSpaceConfirmationProps) => (
  <span>
    You are creating{' '}
    <span className={parentClasses.bold}>
      {pluralize(title, uniqDataLength, true)}
    </span>
  </span>
);

export default CreateSpaceConfirmation;
